export const DISPATCH_MODE = "DISPATCH_MODE";
